import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import {Create} from '@material-ui/icons';
import React from 'react';
import {useTranslation} from 'react-i18next';

interface IPropsDialog {
  open: boolean;
  onClose: () => void;
}

const InvalidSingleVotingDialog: React.FC<IPropsDialog> = ({
  open,

  onClose,
}) => {
  const {t} = useTranslation();
  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog
      aria-labelledby="simple-dialog-title"
      open={open}
      onClose={handleCancel}
      className="confirm-voting-dialog"
    >
      <DialogTitle>{t('votacao-simples-invalida.voto-incompleto')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('votacao-simples-invalida.as-celulas-contem-erros')}
          <br />
          <strong>
            {' '}
            {t('votacao-simples-invalida.corrija-antes-de-enviar')}
          </strong>
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          className={`button-default  full-width`}
          type="button"
          color="primary"
          variant="contained"
          onClick={handleCancel}
          startIcon={<Create />}
        >
          {t('geral.corrigir')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InvalidSingleVotingDialog;



// WEBPACK FOOTER //
// ./src/features/election-single/components/InvalidSingleVotingDialog.tsx